module.exports = __webpack_public_path__ + "img/t-close-folder.e172c00f.png";